import { USER_SESSION_EKY } from './config'

type EnvVariable<T> = Record<typeof process.env.NODE_ENV, T>

// @todo: test and production env api prefix
export const apiPrefix: EnvVariable<string> = {
  //development: '//192.168.1.129/',
  development: '//sit01.e-shenma.com.my/',
  // production: '//47.254.239.37:8090/',
  production: '//e-shenma.com.my/',
  test: '/',
}

export const ENV = {
  get hasLogined() {
    return Boolean(sessionStorage.getItem(USER_SESSION_EKY))
  },
}
